module.exports = __webpack_public_path__ + "img/fashion.3fa1393a.svg";